import React, { useState } from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  
  Alert,
  MenuItem,
  Grid,
  FormControlLabel,
  Switch
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import StartForm from '../components/StartForm';
import api from '../axios';
import { formatarErroAPI } from '../utils/erroAPI';

const CadastroConsolidador = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  const [form, setForm] = useState({
    nome: '',
    email: '',
    senha: '',
    confirmarSenha: '',
    telefone: '',
    telefone_whatsapp: '',
    data_nascimento: '',
    sexo: '',
    endereco: '',
    bairro: '',
    cep: '',
    cidade: '',
    estado: 'PE',
    disponivel_contato: true
  });

  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: e.target.type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // Validações
    if (!form.nome || !form.email || !form.senha || !form.sexo) {
      setError('Preencha todos os campos obrigatórios');
      return;
    }

    if (form.senha !== form.confirmarSenha) {
      setError('As senhas não coincidem');
      return;
    }

    if (form.senha.length < 6) {
      setError('A senha deve ter pelo menos 6 caracteres');
      return;
    }

    setLoading(true);

    try {
      const { confirmarSenha, ...dados} = form;
      await api.post('/consolidadores/cadastro-publico', dados);
      
      setSuccess('Cadastro realizado com sucesso! Aguarde aprovação do administrador.');
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err) {
      setError(formatarErroAPI(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Container maxWidth="md" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 } }}>
        <StartForm
          title="Cadastro de Consolidador"
          description="Preencha os dados abaixo para se cadastrar como consolidador. Seu cadastro será analisado pela equipe administrativa."
          onBack={() => navigate('/login')}
        >
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          {success && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {success}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* Dados Básicos */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Dados Básicos
              </Typography>
            </Grid>

            <Grid item xs={12} md={8}>
              <TextField
                fullWidth
                required
                label="Nome Completo"
                name="nome"
                value={form.nome}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                required
                select
                label="Sexo"
                name="sexo"
                value={form.sexo}
                onChange={handleChange}
              >
                <MenuItem value="masculino">Masculino</MenuItem>
                <MenuItem value="feminino">Feminino</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                type="email"
                label="Email"
                name="email"
                value={form.email}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                type="date"
                label="Data de Nascimento"
                name="data_nascimento"
                value={form.data_nascimento}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            {/* Senha */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                Senha de Acesso
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                type="password"
                label="Senha"
                name="senha"
                value={form.senha}
                onChange={handleChange}
                helperText="Mínimo 6 caracteres"
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                type="password"
                label="Confirmar Senha"
                name="confirmarSenha"
                value={form.confirmarSenha}
                onChange={handleChange}
              />
            </Grid>

            {/* Contato */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                Contato
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Telefone"
                name="telefone"
                value={form.telefone}
                onChange={handleChange}
                placeholder="(81) 99999-9999"
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="WhatsApp"
                name="telefone_whatsapp"
                value={form.telefone_whatsapp}
                onChange={handleChange}
                placeholder="(81) 99999-9999"
              />
            </Grid>

            {/* Endereço */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                Endereço
              </Typography>
            </Grid>

            <Grid item xs={12} md={8}>
              <TextField
                fullWidth
                label="Endereço"
                name="endereco"
                value={form.endereco}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Bairro"
                name="bairro"
                value={form.bairro}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="CEP"
                name="cep"
                value={form.cep}
                onChange={handleChange}
                placeholder="54330-000"
              />
            </Grid>

            <Grid item xs={12} md={5}>
              <TextField
                fullWidth
                label="Cidade"
                name="cidade"
                value={form.cidade}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Estado"
                name="estado"
                value={form.estado}
                onChange={handleChange}
              />
            </Grid>

            {/* Disponibilidade */}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={form.disponivel_contato}
                    onChange={handleChange}
                    name="disponivel_contato"
                    color="primary"
                  />
                }
                label="Estou disponível para fazer contato com visitantes"
              />
            </Grid>

            {/* Botões */}
            <Grid item xs={12} sx={{ mt: 3 }}>
              <Box display="flex" gap={2} justifyContent="flex-end" sx={{ flexDirection: { xs: 'column', sm: 'row' } }}>
                <Button
                  variant="outlined"
                  onClick={() => navigate('/login')}
                  disabled={loading}
                  fullWidth
                  sx={{ width: { sm: 'auto' } }}
                  aria-label="Cancelar cadastro"
                >
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={loading}
                  fullWidth
                  sx={{ width: { sm: 'auto' } }}
                  aria-label="Cadastrar consolidador"
                >
                  {loading ? 'Cadastrando...' : 'Cadastrar'}
                </Button>
              </Box>
            </Grid>
          </Grid>
          </Box>
        </StartForm>
    </Container>
    <Footer />
    </>
  );
};

export default CadastroConsolidador;
